import { Box, createTheme, Divider, Grid, Paper, Table, TableBody, TableCell, Checkbox, TableContainer, TableHead, TableRow, Typography, Button, FormControl, InputLabel, Select, MenuItem, ListItemText, TextField, LinearProgress } from '@material-ui/core';
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
import { noop } from 'lodash';
import React from 'react';
import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { title } from 'process';
import { useUsers } from '../../../common/CommonQueries';
import { useDeliverables } from '../../projectManagementQueries';
import { useErrorHandlingContext } from '../../../common/ErrorHandlingContext';
import { useCustomerDetailsContext } from '../../../common/CustomerDetailsContext';
import { urls } from '../../../common/urls';
import { useFetchContext } from '../../../common/FetchContext';
import { toast } from 'react-toastify';
import moment from 'moment';
const CoverPage= ({ work_order, procedure_definistion }: any) => {


    const location = useLocation();

   

      const { state } = useCustomerDetailsContext();
    

    const rows = [
        { id: 1, revision: "1.0", date: "26/12/2024", summary: "Initial draft" },
        { id: 2, revision: "1.1", date: "27/12/2024", summary: "Minor updates" },
        { id: 3, revision: "2.0", date: "28/12/2024", summary: "Major revision" },
    ];
  const { authAxios } = useFetchContext();


    





const {
    error: errorProjects,
    data: projects,
    isLoading: isLoadingProjects,
    isError: isErrorProjects,
} = useDeliverables(work_order+'');



if (isLoadingProjects) {
    return (
        <LinearProgress />
    )
}
    const history = useHistory();
    


    function openTablePage(): void {
    //   history.push(`/project_management/customer/projects/work_orders/deliverabledata`);
    
    }


return (
    <>
               <div className="summary-report-container" id='content'>
                   <Box
                       style={{
                           maxWidth: '900px',
                           margin: 'auto',
                           padding: '50px 0',
                           boxSizing: 'border-box',
   
                       }}
                   >
                       <Paper elevation={3} 
                       style={{padding: '20px', border: '1px solid #ccc',}}>
                           <Grid container spacing={2} >
                               <Grid item xs={12} >
                                   <Typography variant="body1" style={{ color: '#333', fontWeight: 'bold', fontSize: 'medium', paddingTop: "30px", paddingBottom: '0px', paddingLeft: '10px' }}>
                                       {projects.project_number}
                                   </Typography>
                               </Grid>
                               <Grid item xs={12} >
                                   <Typography variant="body1" style={{ color: '#333', fontWeight: 'bold', fontSize: 'medium', paddingTop: '0px', paddingLeft: '10px' }}>
                                       {projects.title}
                                   </Typography>
                               </Grid>
                               <Grid item xs={12} >
                                   <Typography variant="body1" style={{ color: '#333', fontSize: 'medium', paddingLeft: '10px', paddingBottom: '0px' }}>
                                       {projects.workorder_name}
                                   </Typography>
                               </Grid>
                               <Grid item xs={12} style={{
                                   display: 'flex',
                                   justifyContent: 'center',
                                   alignItems: 'center',
                               }}>
                                   <img
                                       src="/logo.PNG"
                                       alt="Example"
                                       style={{ width: "80%", borderRadius: "8px", height: '400px', }}
                                   />
                               </Grid>
   
                           </Grid>
   
                           {/* <Divider /> */}
   
   
                           <TableContainer component={Paper} style={{
                               border: '1px solid #ccc',
                               display: 'flex',
                               justifyContent: 'center',  
                               alignItems: 'center',      
                               width: "80%",              
                               margin: 'auto'
   
                           }} >
                               <Table >
                                   <TableBody>
                                       <TableRow>
                                           <TableCell style={{ fontWeight: "bold", border: "1px solid black" }}>
                                               Title
                                           </TableCell>
                                           <TableCell style={{ border: "1px solid black" }}>
                                               {projects.title}
                                           </TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell style={{ fontWeight: "bold", border: "1px solid black" }}>
                                               Customer
                                           </TableCell>
                                           <TableCell style={{ border: "1px solid black" }}>
                                               {projects.customer_name}
                                           </TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell style={{ fontWeight: "bold", border: "1px solid black" }}>
                                               Contact Name
                                           </TableCell>
                                           <TableCell style={{ border: "1px solid black" }}>
                                               {projects.contact_name}
                                           </TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell style={{ fontWeight: "bold", border: "1px solid black" }}>
                                               Contact Email
                                           </TableCell>
                                           <TableCell style={{ border: "1px solid black" }}>
                                               {projects.contact_email}
                                           </TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell style={{ fontWeight: "bold", border: "1px solid black" }}>
                                               Project No.
                                           </TableCell>
                                           <TableCell style={{ border: "1px solid black" }}>
                                               {projects.project_number}
                                           </TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell style={{ fontWeight: "bold", border: "1px solid black" }}>
                                               Revision
                                           </TableCell>
                                           <TableCell style={{ border: "1px solid black" }}>
                                               {projects.revision}
                                           </TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell style={{ fontWeight: "bold", border: "1px solid black" }}>
                                               Status
                                           </TableCell>
                                           <TableCell style={{ border: "1px solid black" }}>
                                               {projects.status}
                                           </TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell style={{ fontWeight: "bold", border: "1px solid black" }}>
                                               Date
                                           </TableCell>
                                           <TableCell style={{ border: "1px solid black" }}>
                                               {projects.date}
                                           </TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell style={{ fontWeight: "bold", border: "1px solid black" }}>
                                               Classification
                                           </TableCell>
                                           <TableCell style={{ border: "1px solid black" }}>
                                               {projects.classification}
                                           </TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell style={{ fontWeight: "bold", border: "1px solid black" }}>
                                               Author
                                           </TableCell>
                                           <TableCell style={{ border: "1px solid black" }}>
                                               {projects.author_name}
                                           </TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell style={{ fontWeight: "bold", border: "1px solid black" }}>
                                               Checked
                                           </TableCell>
                                           <TableCell style={{ border: "1px solid black" }}>
                                               {projects.checked_by_name}
                                           </TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell style={{ fontWeight: "bold", border: "1px solid black" }}>
                                               Approved
                                           </TableCell>
                                           <TableCell style={{ border: "1px solid black" }}>
                                               {projects.approved_by_name}
                                           </TableCell>
                                       </TableRow>
                                       <TableRow>
                                           <TableCell style={{ fontWeight: "bold", border: "1px solid black" }}>
                                               Provided By
                                           </TableCell>
                                           <TableCell style={{ border: "1px solid black" }}>
   
   
                                               {projects.provided_by}
   
                                           </TableCell>
                                       </TableRow>
                                   </TableBody>
   
                               </Table>
                           </TableContainer>
                           <Typography variant="subtitle2" style={{ color: '#333', fontWeight: 'bold', fontSize: '20px', }} >
                               History
                           </Typography>
                           <TableContainer component={Paper} style={{
                               border: '1px solid #ccc',
                               display: 'flex',
                               justifyContent: 'center',  
                               alignItems: 'center',      
                               width: "80%",              
                               margin: 'auto' 
   
                           }}>
   
                               <Table >
                                   <TableHead >
                                       <TableRow >
                                           <TableCell style={{ border: '1px solid #ccc', fontSize: '12px' }} >
   
                                           </TableCell>
   
                                           <TableCell style={{ border: '1px solid #ccc', fontSize: '12px' }}>Revision</TableCell>
                                           <TableCell style={{ border: '1px solid #ccc', fontSize: '12px' }}>Date</TableCell>
                                           <TableCell style={{ border: '1px solid #ccc', fontSize: '12px' }}>Summary</TableCell>
                                       </TableRow>
                                   </TableHead>
                                   <TableBody>
                                       {rows.map((row, index) => (
   
   
                                           <TableRow key={row.id} >
                                               <TableCell style={{ border: '1px solid #ccc', }}>
   
                                               </TableCell>
                                               <TableCell style={{ border: '1px solid #ccc', }}></TableCell>
                                               <TableCell style={{ border: '1px solid #ccc', }}></TableCell>
                                               <TableCell style={{ border: '1px solid #ccc', }}></TableCell>
                                           </TableRow>
                                       ))}
                                   </TableBody>
                               </Table>
                           </TableContainer>
   
                           {/* <Divider /> */}
   
   
                           <Typography variant="h6" style={{ padding: '2px', textAlign: "center", border: '1px solid #ccc', fontSize: '12px' }}>
                               IMPORTANT NOTICE AND DISCLAIMER
                           </Typography>
                           <Typography variant="h6" style={{ border: '1px solid #ccc', marginBottom: '2px', fontSize: '10px' }}>
                               THE DATA ENCLOSED IS KIWA PVEL (PVEL LLC) CONFIDENTIAL INFORMATION.  THIS DATA IS STRICTLY CONFIDENTIAL AND IS PROVIDED AS IS AND ON A NO RELIANCE BASIS. THIS DATA IS PROVIDED ONLY AS AN ACCOMMODATION TO THE CUSTOMER. AS OF THE DATE OF THIS DISCLOSURE THIS DATA IS NOT PART OF ANY KIWA PVEL DELIVERABLE. THE CUSTOMER IS INTENDED TO BE THE SOLE RECIPIENT OF THIS DISCLOSURE AND IS RESPONSIBLE FOR ITS USE, INTERPRETATION AND ANY FURTHER DISCLOSURE. KIWA PVEL DISCLAIMS ANY AND ALL LIABILITY ARISING FROM USE OR INTERPRETAION OF THIS DATA.
                           </Typography>
                           <Typography variant='h6' style={{ textAlign: "center", border: '1px solid #ccc', margin: '2px', fontSize: '12px' }}>
                               KEY TO DOCUMENT CLASSIFICATION
                           </Typography>
   
   
                           <Grid container spacing={2} style={{ fontSize: '10px' }}>
                               <Grid item xs={4}  >Commercial in Confidence:</Grid>
                               <Grid item xs={8} >Not to be disclosed outside the Customer's organization </Grid>
                           </Grid>
                           <Grid container spacing={2} style={{ fontSize: '10px' }}>
                               <Grid item xs={4}>Customer's Discretion:</Grid>
                               <Grid item xs={8}>Distribution for information only at the discretion of the Customer (subject to the above Important Notice and Disclaimer). </Grid>
                           </Grid>
   
                       </Paper>
   
                   </Box >
               </div>
           </>
)
}
export default CoverPage


